import { PropsWithChildren } from 'react';

import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.js';
import { cn } from '@sola/ark-core/utils/helpers.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

export type AddPaymentMethodButtonProps = {
  purpose?: 'neutral' | 'negative';
  children: React.ReactNode;
};

export const AddPaymentMethodButtonLabel: React.FC<PropsWithChildren> = ({
  children,
}) => (
  <div className="AddPaymentMethod__button-label flex items-center">
    <ArkIcon iconName="plus" />
    {children}
  </div>
);

export const AddPaymentMethodButtonDescription: React.FC<PropsWithChildren> = ({
  children,
}) => <p className="AddPaymentMethod__button-message">{children}</p>;

export const AddPaymentMethodButton: React.FC<AddPaymentMethodButtonProps> = ({
  children,
  purpose = 'neutral',
  ...props
}) => {
  return (
    <button
      type="button"
      className={cn([
        'AddPaymentMethod rounded-md flex justify-center items-center flex-col gap-snug-xl',
        { 'AddPaymentMethod--negative': purpose === 'negative' },
      ])}
      {...props}
    >
      <LinkStyle
        noUnderline
        noPadding
        inline
        variant="primary"
        purpose={purpose === 'negative' ? 'negative' : undefined}
      >
        <span className="AddPaymentMethod__add-icon flex flex-col items-center gap-snug-md label-md label-potent lg:label-lg label-action-foreground">
          {children}
        </span>
      </LinkStyle>
    </button>
  );
};
